
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import storage from '/src/utils/storage'
import { env } from '/src/var/env'

function useRequireAuth({ children }) {

    const location = useLocation();
    const navigate = useNavigate();
    const [ready, setReady] = useState(false);

    const params = new URLSearchParams(location.search);
    const sessionCode = params.get('session');

    useEffect(() => {
        if (!sessionCode) {
            setReady(true);
            return;
        }

        const exchange = async () => {
            const response = await fetch(env.REACT_APP_API_PATH + '/auth/session/' + sessionCode);
            const data = await response.json();

            if (response.ok) {
                storage('local').set('token', data.token);
                storage('local').set('refresh_token', data.refresh_token);
                storage('local').set('user', data.user);
                storage('session').set('company', data.company);
                storage('session').set('permissions', data.permissions);
            }

            navigate(location.pathname, { replace: true });
            setReady(true);
        };

        exchange();
    }, []);

    if (!ready) return null;

    if (localStorage.getItem('token') == null) {
        return <Navigate to='/login' state={{ from: location.pathname }} />
    }

    return children;
}

export default useRequireAuth;